export class NodePath {
  originalPath: string;
  pathElements: number[];

  constructor(path: string) {
    this.originalPath = path;
    this.pathElements = path.split(".").map(Number);
  }
}
